import { HTMLAttributes } from "react";

export default function Stripe(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9005 23.6439C45.9005 20.5292 44.3918 18.0715 41.5082 18.0715C38.6125 18.0715 36.8604 20.5292 36.8604 23.6196C36.8604 27.2818 38.9288 29.1312 41.8975 29.1312C43.3454 29.1312 44.4404 28.8027 45.2678 28.3404V25.907C44.4404 26.3207 43.4914 26.5762 42.2869 26.5762C41.1067 26.5762 40.0603 26.1625 39.9265 24.7268H45.8761C45.8761 24.5686 45.9005 23.9359 45.9005 23.6439ZM39.89 22.4881C39.89 21.1132 40.7295 20.5414 41.496 20.5414C42.2382 20.5414 43.0291 21.1132 43.0291 22.4881H39.89Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.164 18.0715C30.9716 18.0715 30.2051 18.6312 29.7793 19.0205L29.6211 18.2662H26.9444V32.4528L29.9861 31.8079L29.9983 28.3647C30.4363 28.681 31.0811 29.1312 32.1518 29.1312C34.3297 29.1312 36.3129 27.3792 36.3129 23.5223C36.3008 19.9939 34.2932 18.0715 32.164 18.0715ZM31.434 26.4545C30.7161 26.4545 30.2903 26.199 29.9983 25.8826L29.9861 21.3687C30.3025 21.0159 30.7405 20.7725 31.434 20.7725C32.5412 20.7725 33.3077 22.0136 33.3077 23.6074C33.3077 25.2378 32.5533 26.4545 31.434 26.4545Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.759 17.3536L25.8129 16.6966V14.2267L22.759 14.8716V17.3536Z"
        fill="#635BFF"
      />
      <path
        d="M25.8129 18.2783H22.759V28.9244H25.8129V18.2783Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4861 19.1787L19.2914 18.2783H16.6633V28.9244H19.7051V21.7094C20.4229 20.7725 21.6396 20.9429 22.0168 21.0767V18.2783C21.6275 18.1323 20.2039 17.8646 19.4861 19.1787Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4026 15.6381L10.4339 16.2708L10.4217 26.0165C10.4217 27.8172 11.7722 29.1434 13.573 29.1434C14.5706 29.1434 15.3007 28.9609 15.7022 28.7419V26.272C15.3128 26.4302 13.3904 26.9898 13.3904 25.1891V20.8699H15.7022V18.2783H13.3904L13.4026 15.6381Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17778 21.3687C5.17778 20.8942 5.56712 20.7117 6.21197 20.7117C7.13665 20.7117 8.30468 20.9915 9.22936 21.4904V18.6312C8.21951 18.2297 7.22182 18.0715 6.21197 18.0715C3.74208 18.0715 2.09955 19.3612 2.09955 21.5147C2.09955 24.8728 6.72298 24.3374 6.72298 25.7853C6.72298 26.345 6.2363 26.5275 5.55495 26.5275C4.5451 26.5275 3.25541 26.1138 2.23338 25.5541V28.4499C3.36491 28.9365 4.5086 29.1434 5.55495 29.1434C8.08567 29.1434 9.82554 27.8902 9.82554 25.7123C9.81337 22.0866 5.17778 22.7314 5.17778 21.3687Z"
        fill="#635BFF"
      />
    </svg>
  )
}
